import styled from 'styled-components';

// Neutral secondary button per the design system — Cancel is never green.
// Green (`--primary`) is reserved for the primary action (SaveButton).
export const CancelButton = styled.div<{
  disabled: boolean;
  disableHoverEffect?: boolean;
}>`
  box-sizing: border-box;
  flex: 1;
  display: flex;
  height: var(--btn-h-xl);
  padding: var(--btn-px-lg);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-sm);
  border-radius: var(--radius-button);
  border: 1px solid var(--border);
  cursor: pointer;

  font-family: var(--font-primary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);

  background: transparent;
  color: var(--foreground);
  transition:
    background 120ms ease,
    border-color 120ms ease,
    filter 120ms ease;

  ${props =>
    !props.disabled &&
    !props.disableHoverEffect &&
    `&:hover {
      background: var(--surface-elevated);
      border-color: var(--text-muted);
    }`}

  ${props =>
    props.disabled &&
    `
    opacity: 0.7;
  `}
`;

export const DeleteButton = styled(CancelButton)`
  background: var(--destructive);
  border-color: transparent;
  color: var(--destructive-foreground);
  font-weight: var(--font-weight-semi-bold);

  ${props =>
    !props.disabled &&
    !props.disableHoverEffect &&
    `&:hover {
      background: var(--destructive);
      border-color: transparent;
      filter: brightness(1.08);
    }`}
`;

export const SaveButton = styled(CancelButton)`
  background: var(--primary);
  border-color: transparent;
  color: var(--background);
  font-weight: var(--font-weight-semi-bold);

  ${props =>
    !props.disabled &&
    !props.disableHoverEffect &&
    `&:hover {
      background: var(--primary-hover);
      border-color: transparent;
    }`}
`;
